class CartRecommendations extends HTMLElement {
  constructor() {
    super();
    this.slider = null;
  }

  connectedCallback() {
    this.performRecommendations();
  }

  performRecommendations() {
    const recommendations = this.querySelector('[data-recommendations]');
    if (!recommendations) return;
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const recommendationsHMTL = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('[data-recommendations]').innerHTML;
        if (!recommendationsHMTL) return;
        this.classList.remove('hidden');
        recommendations.innerHTML = recommendationsHMTL;
        this.initSlider();
        this.initAddButtons();
      });
  }

  initSlider() {
    this.slider = new Swiper(this.querySelector('.swiper'), {
      slidesPerView: 'auto',
      spaceBetween: 8
    });
  }

  initAddButtons() {
    this.querySelectorAll('.cart-rec-add-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const card = btn.closest('.cart-recommendations__item');
        const selector = card.querySelector('.cart-rec-mini-selector');
        const isOpen = !selector.hidden;

        if (isOpen) {
          selector.hidden = true;
          btn.classList.remove('is-open');
        } else {
          // Close any other open selectors
          this.querySelectorAll('.cart-rec-mini-selector').forEach(s => { s.hidden = true; });
          this.querySelectorAll('.cart-rec-add-btn').forEach(b => b.classList.remove('is-open'));

          selector.hidden = false;
          btn.classList.add('is-open');

          // If no options (default variant only), add immediately
          const selects = selector.querySelectorAll('.cart-rec-mini-selector__select');
          if (selects.length === 0) {
            this.addToCart(card, selector);
          }
        }
      });
    });

    this.querySelectorAll('.cart-rec-mini-selector__cta').forEach(cta => {
      cta.addEventListener('click', (e) => {
        e.preventDefault();
        const card = cta.closest('.cart-recommendations__item');
        const selector = cta.closest('.cart-rec-mini-selector');
        this.addToCart(card, selector);
      });
    });
  }

  addToCart(card, selector) {
    const variants = JSON.parse(card.dataset.variants || '[]');
    const selects = selector.querySelectorAll('.cart-rec-mini-selector__select');
    const cta = selector.querySelector('.cart-rec-mini-selector__cta');
    const errorEl = selector.querySelector('.cart-rec-mini-selector__error');

    // Build selected options array
    const selectedOptions = Array.from(selects).map(s => s.value);

    // Find matching available variant
    let variantId = null;
    for (const v of variants) {
      if (!v.available) continue;
      const match = selectedOptions.every((val, i) => v.options[i] === val);
      if (match) { variantId = v.id; break; }
    }

    // If no available variant with those options, try any (even unavailable) to show error
    if (!variantId) {
      // Check if combo exists but is sold out
      for (const v of variants) {
        const match = selectedOptions.every((val, i) => v.options[i] === val);
        if (match) { variantId = v.id; break; }
      }
    }

    // No default variant case (product with no options)
    if (!variantId && variants.length > 0) variantId = variants[0].id;

    if (!variantId) return;

    // Check availability
    const selectedVariant = variants.find(v => v.id === variantId);
    if (selectedVariant && !selectedVariant.available) {
      errorEl.textContent = window.cartRecStrings?.soldOut || 'Agotado en esa combinación';
      errorEl.hidden = false;
      return;
    }

    errorEl.hidden = true;
    cta.disabled = true;
    const originalText = cta.textContent;
    cta.textContent = '…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(res => res.json())
    .then(data => {
      if (data.status === 422 || data.description) {
        throw new Error(data.description || 'Error');
      }
      // Refresh cart drawer
      this.refreshCart();
      // Close selector
      selector.hidden = true;
      const addBtn = card.querySelector('.cart-rec-add-btn');
      if (addBtn) addBtn.classList.remove('is-open');
    })
    .catch(err => {
      errorEl.textContent = err.message || 'Error al añadir';
      errorEl.hidden = false;
    })
    .finally(() => {
      cta.disabled = false;
      cta.textContent = originalText;
    });
  }

  refreshCart() {
    // Try native Shopify cart drawer refresh events
    document.dispatchEvent(new CustomEvent('cart:refresh'));

    // Fallback: fetch cart and update drawer if cart-drawer custom element exists
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      fetch(`${window.Shopify.routes.root}?sections=cart-drawer`)
        .then(r => r.json())
        .then(data => {
          const key = Object.keys(data)[0];
          if (key && data[key]) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(data[key], 'text/html');
            const newBody = doc.querySelector('[data-cart-body]');
            const currentBody = document.querySelector('[data-cart-body]');
            if (newBody && currentBody) currentBody.innerHTML = newBody.innerHTML;

            // Re-init recommendations
            const newRec = document.querySelector('cart-recommendations');
            if (newRec) newRec.performRecommendations();
          }
        });
    } else {
      // Last resort: reload the cart section via Shopify sections API
      fetch('/cart?view=ajax')
        .then(() => {
          // Trigger a re-render by dispatching a sections update
          document.dispatchEvent(new CustomEvent('cart:update'));
        });
    }
  }
}

customElements.define('cart-recommendations', CartRecommendations);
